module.exports = __webpack_public_path__ + "static/media/logo-iwk.7ff33287.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-iwk.png
// module id = 142
// module chunks = 0